import { Component, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { DataService } from '@services/data.service';
import { ConfigService } from '@services/config.service';
import { HeaderLink } from '@other/interfaces';
import { CognosService } from '@services/cognos.service';
import { ConfigState } from '@store/config.state';
import { Store } from '@ngxs/store';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';
import { LogService } from '@services/log.service';

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  loading$ !: Observable<boolean>;
  reports$ !: Observable<HeaderLink[]>;
  reports = new BehaviorSubject<HeaderLink[]>([]);
  private capabilitiesSubscription?: Subscription;

  constructor(
    public data: DataService,
    public config: ConfigService,
    private _cognos: CognosService,
    private logger: LogService,
    private _store: Store
  ) {
    const lightThemeStorage = localStorage.getItem('light_theme');
    if (lightThemeStorage === 'yes') {
      this.logger.info("HeaderComponent","constructor", "lightThemeStorage is yes, setting lightTheme to true")
      this.data.lightTheme.setValue(true);
    }
    this.loading$ = this._store.select(ConfigState.GetLoading).pipe( delay(0) );
  }

  ngOnInit() {
    // Update reports initially
    this.updateReports();
    
    // Subscribe to userCapabilities changes to update menu when capabilities are loaded
    this.capabilitiesSubscription = this._cognos.userCapabilities.subscribe(() => {
      this.logger.info("HeaderComponent","ngOnInit", "userCapabilities changed, updating reports")
      this.updateReports();
    });
  }

  ngOnDestroy() {
    if (this.capabilitiesSubscription) {
      this.capabilitiesSubscription.unsubscribe();
    }
  }

  openSidenav(): void {
    this.logger.info("HeaderComponent","openSidenav", "openSidenav()")
    this.data.sidenavOpened.next(!this.data.sidenavOpened.getValue());
  }

  private updateReports(): void {
    const links = this.getHeaderReports();
    this.logger.info("HeaderComponent","updateReports", "Updating reports with " + links.length + " links")
    this.reports.next(links);
  }

  getHeaderReports(): HeaderLink[] {
    this.logger.info("HeaderComponent","getReports", "getReports()")
    // Use getLinksWithAccess() to filter by user capabilities, matching mobile behavior
    const links = this._cognos.getLinksWithAccess();
    this.logger.info("HeaderComponent","getReports", "reportLength: "+links.length)
    this.logger.info("HeaderComponent","getReports", "links: "+JSON.stringify(links.map(l => l.text)))
    this.logger.info("HeaderComponent","getReports", "userCapabilities: "+JSON.stringify(this._cognos.userCapabilities.getValue()))
    return links;
  }

}
